import { HeadingItem } from 'components'
import { TripContext } from 'contexts'
import React, { FC, Fragment, useContext } from 'react'
import { LineItem, ReturnChangeReason, ReturnItem } from 'services/types'
import './returnitem-card.scss'

type Props = {
    returnItemId: number
}

export const ReturnItemCard: FC<Props> = ({ returnItemId }) => {

    const tripContext = useContext(TripContext)

    const returnItem: ReturnItem = tripContext.returnItems.find(item => item.id === returnItemId) ?? {} as ReturnItem
    const lineItem: LineItem = tripContext.lineItems.find(item => item.id === returnItem.lineItemId) ?? {} as LineItem
    const returnReason: ReturnChangeReason = tripContext.returnChangeReasons.find(reason => reason.id === returnItem.changeReasonCode) ?? {} as ReturnChangeReason

    return (
        <Fragment>
            <div className={'card-material'}>
                <HeadingItem text={`Authorization No : ${returnItem.orderId}`} />
                <div className={'verify-item-details-description'}>{lineItem.longDescription ?? (lineItem.description ?? 'No description available')}</div>
                <div className={'returnitem-card-content'}>
                    <div className={'returnitem-card-subheading'} style={{ width: '42%' }}>Item Id : {lineItem.id}</div>
                    <div className={'returnitem-card-subheading'} style={{ width: '27%' }}>Rtn : {returnItem.returnQuantity}</div>
                    <div className={'returnitem-card-subheading'} style={{ width: '30%' }}>Counted : {returnItem.countedQuantity}</div>
                </div>
                <div className={'reconcile-reason-grid-heading'}>
                    <div className={'reconcile-reason-grid-text-heading'} style={{ width: '60%' }}>Reason</div>
                    <div className={'reconcile-reason-grid-text-heading'} style={{ width: '40%' }}>Rtn Sticker</div>
                </div>
                <div className={'reconcile-reason-grid-row'}>
                    <div className={'reconcile-reason-grid-text'} style={{ width: '60%' }}>{returnReason.description ?? 'N/A'}</div>
                    <div className={'reconcile-reason-grid-text'} style={{ width: '40%' }}>{returnItem.returnSticker ?? returnItem.reasonForNoSticker}</div>
                </div>
            </div>
        </Fragment>
    )
}